(function () {
  const BUNDLE_HANDLE = "expositor-resenas-google";
  // size = unidades de carrito por pack (variantes de pack = 1).
  const PACK_META = {
    unidad: { size: 1, label: "1 Unidad", total: 34999, compare: 0 },
    pyme: { size: 1, label: "Pack PYME", total: 59999, compare: 104997 },
    escala: { size: 1, label: "Pack ESCALA", total: 98999, compare: 209994 },
  };

  const root = document.querySelector("[data-tg-drawer]");
  if (!root) return;

  const bodyEl = root.querySelector("[data-tg-drawer-body]");
  const pricingEl = document.querySelector("[data-tg-pricing]");
  let pricing = { compareUnit: 34999, tiers: [], unitAboveMax: 16500 };
  try {
    if (pricingEl) pricing = JSON.parse(pricingEl.textContent);
  } catch (_) {}

  function formatArs(n) {
    const s = String(Math.round(Number(n) || 0));
    return "$" + s.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function openDrawer() {
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("tg-drawer-open");
  }

  function closeDrawer() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("tg-drawer-open");
  }

  window.TapGOCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshFromCart,
  };

  root.querySelectorAll("[data-tg-drawer-close]").forEach((el) => {
    el.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && root.classList.contains("is-open")) closeDrawer();
  });

  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-tg-open-cart]");
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      refreshFromCart();
    }
  });

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart fetch failed");
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error("cart change failed");
    return res.json();
  }

  function emptyHtml() {
    return (
      '<div class="tg-cart tg-cart--empty" data-tg-cart data-empty="true">' +
      '<p class="tg-cart__empty">Tu carrito está vacío.</p>' +
      '<a href="/products/expositor-resenas-google#tapgo-bundle" class="tg-cart__empty-cta" data-tg-drawer-close>Ver producto</a>' +
      "</div>"
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function isBundleItem(item) {
    const handle = item.handle || "";
    return (
      handle === BUNDLE_HANDLE ||
      (item.url && String(item.url).indexOf("/products/" + BUNDLE_HANDLE) !== -1) ||
      (item.properties && item.properties._tapgo_bundle === "1")
    );
  }

  function resolvePack(item) {
    const props = item.properties || {};
    const key = props._tapgo_pack;
    if (key && PACK_META[key]) {
      const meta = PACK_META[key];
      return {
        key: key,
        size: Number(props._tapgo_pack_size) || meta.size,
        label: props._tapgo_pack_label || meta.label,
        unitTotal: Number(props._tapgo_pack_total) || meta.total,
        unitCompare: Number(String(props._tapgo_pack_compare || "").replace(/[^\d]/g, "")) || meta.compare,
      };
    }

    const title = String(item.variant_title || item.title || "");
    if (/pack\s*escala/i.test(title)) {
      return { key: "escala", size: 1, label: "Pack ESCALA", unitTotal: 98999, unitCompare: 209994 };
    }
    if (/pack\s*pyme/i.test(title)) {
      return { key: "pyme", size: 1, label: "Pack PYME", unitTotal: 59999, unitCompare: 104997 };
    }

    // Fallback líneas viejas (qty de la variante unitaria)
    const q = item.quantity || 0;
    if (q % 6 === 0 && q > 0) {
      return { key: "escala", size: 6, label: "Pack ESCALA", unitTotal: 98999, unitCompare: 209994 };
    }
    if (q % 2 === 0 && q > 0) {
      return { key: "pyme", size: 2, label: "Pack PYME", unitTotal: 59999, unitCompare: 104997 };
    }
    return { key: "unidad", size: 1, label: "1 Unidad", unitTotal: 34999, unitCompare: 0 };
  }

  function packCountFor(item, pack) {
    const size = Math.max(1, pack.size || 1);
    return Math.max(1, Math.round((item.quantity || 0) / size));
  }

  function lineTotalFor(item, pack) {
    if (item.final_line_price != null) {
      return (item.final_line_price || 0) / 100;
    }
    return packCountFor(item, pack) * (pack.unitTotal || 0);
  }

  function lineCompareFor(item, pack) {
    return packCountFor(item, pack) * (pack.unitCompare || 0);
  }

  function lineThumb(item) {
    const fallback = root.getAttribute("data-img-google") || "";
    const src = item.image || fallback;
    if (!src) return "";
    return `<img src="${src}" alt="" width="72" height="72" loading="lazy" class="tg-cart__img">`;
  }

  function lineHtml(item, isBundle) {
    if (!isBundle) {
      return `<div class="tg-cart__row" data-tg-line data-variant-id="${item.variant_id}" data-line-key="${item.key}" data-line-qty="${item.quantity}" data-pack-size="1" data-is-bundle="false">
        <div class="tg-cart__media">${lineThumb(item)}</div>
        <div class="tg-cart__info">
          <div class="tg-cart__name">${escapeHtml(item.product_title || item.title || "")}</div>
          <p class="tg-cart__meta">× ${item.quantity}</p>
        </div>
        <div class="tg-cart__end">
          <span class="tg-cart__price">${formatArs((item.final_line_price || 0) / 100)}</span>
          <button type="button" class="tg-cart__remove" data-tg-remove aria-label="Quitar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
          </button>
        </div>
      </div>`;
    }

    const pack = resolvePack(item);
    const packs = packCountFor(item, pack);
    const rowTotal = lineTotalFor(item, pack);
    const name = pack.label || item.product_title || item.title || "";

    return `<div class="tg-cart__row" data-tg-line data-variant-id="${item.variant_id}" data-line-key="${item.key}" data-line-qty="${item.quantity}" data-pack-size="${pack.size}" data-is-bundle="true">
      <div class="tg-cart__media">${lineThumb(item)}</div>
      <div class="tg-cart__info">
        <div class="tg-cart__name">${escapeHtml(name)}</div>
        <div class="tg-cart__stepper">
          <button type="button" class="tg-cart__step-btn" data-tg-qty-down aria-label="Quitar pack">−</button>
          <span class="tg-cart__qty" data-tg-qty-value>${packs}</span>
          <button type="button" class="tg-cart__step-btn" data-tg-qty-up aria-label="Agregar pack">+</button>
        </div>
      </div>
      <div class="tg-cart__end">
        <span class="tg-cart__price" data-tg-line-price>${formatArs(rowTotal)}</span>
        <button type="button" class="tg-cart__remove" data-tg-remove aria-label="Quitar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
    </div>`;
  }

  function renderCart(cart) {
    const items = cart.items || [];
    if (!items.length) {
      bodyEl.innerHTML = emptyHtml();
      bodyEl.querySelectorAll("[data-tg-drawer-close]").forEach((el) => {
        el.addEventListener("click", closeDrawer);
      });
      updateBadge(0);
      return;
    }

    let displayTotal = 0;
    let compareTotal = 0;
    let packBadge = 0;
    let lines = "";

    items.forEach((item) => {
      const isBundle = isBundleItem(item);
      if (isBundle) {
        const pack = resolvePack(item);
        const packs = packCountFor(item, pack);
        packBadge += packs;
        displayTotal += lineTotalFor(item, pack);
        compareTotal += lineCompareFor(item, pack);
      } else {
        displayTotal += (item.final_line_price || 0) / 100;
        packBadge += item.quantity || 0;
      }
      lines += lineHtml(item, isBundle);
    });

    const compareHtml =
      compareTotal > displayTotal
        ? `<span class="tg-cart__compare" data-tg-cart-compare>${formatArs(compareTotal)}</span>`
        : `<span class="tg-cart__compare" data-tg-cart-compare hidden></span>`;

    const perkShield =
      '<svg class="tg-cart__perk-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
    const perkTruck =
      '<svg class="tg-cart__perk-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';

    bodyEl.innerHTML = `<div class="tg-cart" data-tg-cart data-product-handle="${BUNDLE_HANDLE}">
      <div class="tg-cart__lines" data-tg-cart-lines>${lines}</div>
      <aside class="tg-cart__checkout" aria-label="Resumen del carrito">
        <details class="tg-cart__discount">
          <summary class="tg-cart__discount-row">
            <span>Descuento</span>
            <span class="tg-cart__discount-toggle" aria-hidden="true">+</span>
          </summary>
          <p class="tg-cart__discount-note">Podés aplicar tu código en la página de pago.</p>
        </details>
        <div class="tg-cart__total-row">
          <span class="tg-cart__total-label">Total estimado</span>
          <div class="tg-cart__total-prices">
            <span class="tg-cart__total" data-tg-cart-total>${formatArs(displayTotal)}</span>
            ${compareHtml}
          </div>
        </div>
        <button type="button" class="tg-cart__checkout-btn" data-tg-checkout>Finalizar compra</button>
        <ul class="tg-cart__perks" role="note">
          <li class="tg-cart__perk">${perkShield}<span>3 Cuotas sin interés</span></li>
          <li class="tg-cart__perk">${perkTruck}<span>Envío gratis</span></li>
        </ul>
      </aside>
    </div>`;

    bindCartEvents();
    updateBadge(packBadge);
  }

  function bindCartEvents() {
    bodyEl.querySelectorAll("[data-tg-qty-up]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const row = btn.closest("[data-tg-line]");
        const key = row.getAttribute("data-line-key");
        const qty = Number(row.getAttribute("data-line-qty") || 0);
        const packSize = Math.max(1, Number(row.getAttribute("data-pack-size") || 1));
        const cart = await changeLine(key, qty + packSize);
        renderCart(cart);
      });
    });
    bodyEl.querySelectorAll("[data-tg-qty-down]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const row = btn.closest("[data-tg-line]");
        const key = row.getAttribute("data-line-key");
        const qty = Number(row.getAttribute("data-line-qty") || 0);
        const packSize = Math.max(1, Number(row.getAttribute("data-pack-size") || 1));
        const next = Math.max(0, qty - packSize);
        const cart = await changeLine(key, next);
        renderCart(cart);
      });
    });
    bodyEl.querySelectorAll("[data-tg-remove]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const row = btn.closest("[data-tg-line]");
        const key = row.getAttribute("data-line-key");
        const cart = await changeLine(key, 0);
        renderCart(cart);
      });
    });
    const checkout = bodyEl.querySelector("[data-tg-checkout]");
    if (checkout) {
      checkout.addEventListener("click", () => {
        window.location.href = "/checkout";
      });
    }
  }

  function updateBadge(count) {
    document.querySelectorAll("[data-tg-cart-count]").forEach((el) => {
      el.textContent = String(count);
      el.hidden = !count;
    });
  }

  async function refreshFromCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (err) {
      console.error(err);
    }
  }

  if (bodyEl.querySelector("[data-tg-cart]:not([data-empty])")) {
    // Re-render from live cart so pack logic applies even to SSR
    refreshFromCart();
  } else {
    bodyEl.querySelectorAll("[data-tg-drawer-close]").forEach((el) => {
      el.addEventListener("click", closeDrawer);
    });
  }

  document.addEventListener("tapgo:cart-updated", () => {
    refreshFromCart().then(openDrawer);
  });
})();
